import Detail from './Detail'
import Functions from './Functions'
import Spaces from './Spaces'
import Roles from './Roles'
import Users from './Users'
import Domains from './Domains'

export {
  Detail
  Domains
  Functions
  Spaces
  Roles
  Users
}
